import { useId, useLayoutEffect } from 'react';
import { useDesignWorkspace } from './DesignWorkspaceProvider';

/** Reports editor state without installing another navigation blocker or owning another guard. */
export const useDesignWorkspaceDirty = (dirty: boolean) => {
  const owner = useId();
  const { reportDirty } = useDesignWorkspace();
  useLayoutEffect(() => {
    reportDirty?.(owner, dirty);
    return () => reportDirty?.(owner, false);
  }, [owner, dirty, reportDirty]);
};
